// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__1_rTs","choiceBoxes":"toolbarselects_choiceBoxes__3lgpr","simpleField":"toolbarselects_simpleField__1ZwE7"};